import Logger from "@cappelendamm/logger";
import { CreateCustomer } from "../mutations/CreateCustomer.core.js";
import { selectCreateOrganizationCustomerInput } from "../selectors/selectCreateCustomerForOrganizationInput.js";
export async function createOrganizationAsCustomer(customerInput, { client }) {
    const reference = customerInput.email?.trim() || customerInput.identifier;
    Logger.log(`Creating new customer with reference: ${reference} (source: ${customerInput.email ? "email" : "identifier"}).`);
    const sanitizeCustomer = selectCreateOrganizationCustomerInput(customerInput);
    const result = await client.core.request(CreateCustomer, {
        input: {
            ...sanitizeCustomer,
        },
    });
    if (result.createCustomer.__typename !== "Customer") {
        throw new Error(`Error creating organization customer with reference: ${reference}. ErrorName: ${result.createCustomer.errorName}. Message: ${result.createCustomer.message}`);
    }
    Logger.log(`Completed creating organization customer with identifier ${result.createCustomer.identifier} (reference: ${reference}).`);
    return result.createCustomer.identifier;
}
